import React, { useContext, useState, useMemo } from 'react';

const ApplicationContext = React.createContext(null);


const ApplicationContextProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const clearState = () => setState(null);

  const value = useMemo(() => ({
    application: state,
    setApplication: setState,
    clearApplication: clearState,
  }), [state]);

  return (
    <ApplicationContext.Provider value={value}>
      {children}
    </ApplicationContext.Provider>
  );
};


const ApplicationContextConsumer = ApplicationContext.Consumer;


const useApplication = () => {
  return useContext(ApplicationContext);
};


export { useApplication, ApplicationContext, ApplicationContextProvider, ApplicationContextConsumer };
export default useApplication;
